export const translationEngDefault = {
    SkhemataBlogFeatured: {
        readMore: 'READ MORE',
    }
};
//# sourceMappingURL=eng.js.map